export default "__VITE_ASSET__B30EQpGm__"